import { ITagResult } from '~src/httpClient/serverApi/types/IResponse';
import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { CustomDomainResponse, GetCustomDomainRequest } from '../types/CustomDomainTypes';


export class GetCustomDomainTagRequest extends TagRequest<GetCustomDomainRequest,  ICustomDomainResult> {
    constructor(siteLuid: GetCustomDomainRequest) {
      super('custom_domains_service', 'getSiteCustomDomain', siteLuid);
    }
}

export type ICustomDomainResult = ITagResult & CustomDomainResponse;